export default __webpack_public_path__ + "static/media/030-romantic dinner.851564cf.svg";